/**
 * Render an inline field error message for form validation.
 * Shared across compliance form components.
 */
export const fieldError = (errors: Record<string, string>, path: string) =>
  errors[path] ? (
    <p className="text-xs text-red-500 mt-1">{errors[path]}</p>
  ) : null;
